import PhoneInput from 'react-phone-number-input'
import type { Country } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { cn } from 'src/utils/style'

export { isValidPhone } from 'src/utils/phone'

interface PhoneNumberInputProps {
  value: string | undefined
  onChange: (value: string | undefined) => void
  onBlur?: () => void
  label?: string
  placeholder?: string
  disabled?: boolean
  className?: string
  /** Pre-selected country; `null` starts with no country (any number). */
  defaultCountry?: Country | null
  /** Restricts the country selector to these countries. */
  countries?: Country[]
  'data-testid'?: string
}

/**
 * Reusable phone number input with country selector dropdown.
 * Outputs E.164 format strings, matching django-phonenumber-field.
 * Default country is Colombia (CO) but accepts any international number.
 */
export const PhoneNumberInput = ({
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  disabled = false,
  className,
  defaultCountry = 'CO',
  countries,
  'data-testid': dataTestId,
}: PhoneNumberInputProps) => {
  return (
    <section className="flex w-full flex-col items-start">
      {label && <span className="mb-1 block text-sm font-medium text-primary">{label}</span>}
      <PhoneInput
        defaultCountry={defaultCountry ?? undefined}
        countries={countries}
        international
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        data-testid={dataTestId}
        className={cn(['phone-number-input-wrapper w-full', className])}
        numberInputProps={{
          className: cn([
            'w-full rounded-r-md border border-l-0 bg-surface p-2',
            'text-text-primary placeholder:font-thin placeholder:text-text-placeholder',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-strong',
            'disabled:cursor-not-allowed disabled:opacity-50',
          ]),
        }}
      />
    </section>
  )
}
